import { FieldPath, serverTimestamp } from 'firebase/firestore';

// Fact names are admin-authored (Firestore-driven extraction configs) and can
// contain characters that are illegal in dotted string field paths ("/" in
// "Fracture/Injury Detail" broke every dotted-path write silently). FieldPath
// segments accept any characters, so all structuredInfo writes must go
// through these helpers, never template-string paths.

export function factFieldPath(factName, property) {
    return new FieldPath('structuredInfo', factName, property);
}

export function factUpdateArgs(factName, property, value) {
    return [
        factFieldPath(factName, property), value,
        new FieldPath('last_modified_date'), serverTimestamp(),
    ];
}

export function markAllVerifiedArgs(structuredInfo) {
    const args = [];
    Object.keys(structuredInfo || {}).forEach((key) => {
        args.push(factFieldPath(key, 'verified'), true);
    });
    args.push(new FieldPath('last_modified_date'), serverTimestamp());
    return args;
}
